import React, { useState } from 'react';
import './FQA.css';
import Arrow from '../../Aseets/Img/arrow.svg';

const FQA_cards = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className='fqa_div2'>
        <div className='fqa_div1'>
          <h3 className='fqa_text1'>{props.title}</h3>
          <img
            className={`arrow_icon ${isOpen ? 'arrow_flipped' : ''}`}
            src={Arrow}
            alt=""
            onClick={() => setIsOpen(!isOpen)}
          />
        </div>
        {isOpen && <p className='fqa_text2'>{props.text}</p>}
      </div>
    </>
  );
};

export default FQA_cards;